<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    CONVÊNIO
                    <b-badge variant="warning" class="ml-2">{{
                        operacao
                    }}</b-badge>
                </span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <div>
                    <b-row>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label>Nº do Convênio</label>
                                a
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        placeholder="Nº do Convênio"
                                        v-model="vcCodigoEstruturado"
                                        v-mask="'AA###/##'"
                                        :disabled="!habilitaCampos"
                                    ></b-form-input>
                                    <b-form-invalid-feedback
                                        >Nº do Convênio é
                                        obrigatório</b-form-invalid-feedback
                                    >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label>Ata Direx</label>
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        placeholder="Ata Direx"
                                        v-model="nuAtaDirex"
                                        :disabled="!habilitaCampos"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button
                                            variant="primary"
                                            @click="pesquisarAtaDirex()"
                                            title="Clique para pesquisar a Ata Direx"
                                            :disabled="!habilitaCampos"
                                        >
                                            <i class="fa fa-search"></i>
                                        </b-button>
                                    </b-input-group-append>
                                    <b-form-invalid-feedback
                                        >Ata Direx é
                                        obrigatório</b-form-invalid-feedback
                                    >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label>Nº Processo</label>
                                <b-input-group>
                                    <b-form-select
                                        type="text"
                                        placeholder="Nº Processo"
                                        v-model="idProcessoAta"
                                        :options="processosAta"
                                        value-field="idProcessoAta"
                                        text-field="nuProcesso"
                                        :disabled="!habilitaCampos"
                                    ></b-form-select>
                                    <b-form-invalid-feedback
                                        >Nº Processo é
                                        obrigatório</b-form-invalid-feedback
                                    >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="12">
                            <b-form-group>
                                <label>Objeto</label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="vcObjeto"
                                        placeholder="Objeto"
                                        :rows="2"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback
                                        >Objeto é
                                        obrigatório</b-form-invalid-feedback
                                    >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label>Convenente</label>
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        v-model="convenenteRM.cnpj"
                                        placeholder="CNPJ"
                                        v-mask="['##.###.###/####-##']"
                                        :disabled="!habilitaCampos"
                                    >
                                    </b-form-input>
                                    <b-input-group-append>
                                        <b-button
                                            variant="primary"
                                            @click="pesquisarConvenente()"
                                            title="Clique para pesquisar o Convenente"
                                            :disabled="!habilitaCampos"
                                        >
                                            <i class="fa fa-search"></i>
                                        </b-button>
                                    </b-input-group-append>
                                    <b-form-invalid-feedback
                                        >Convenente é
                                        obrigatório</b-form-invalid-feedback
                                    >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="10">
                            <b-form-group>
                                <label>Razão Social</label>
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        placeholder="Razão Social"
                                        v-model="convenenteRM.nome"
                                        :disabled="true"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label>Valor Total</label>
                                <b-input-group>
                                    <money
                                        v-model="nuValorConvenio"
                                        v-bind="money"
                                        class="form-control text-right"
                                        :disabled="true"
                                    ></money>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label>Receita Prevista</label>
                                <b-input-group>
                                    <money
                                        v-model="nuValorReceitaPrevista"
                                        v-bind="money"
                                        class="form-control text-right"
                                    ></money>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label>Vigência Inicial</label>
                                <b-input-group>
                                    <date-picker
                                        v-model="dtInicioVigencia"
                                        @input.native="
                                            $v.dtInicioVigencia.$touch()
                                        "
                                        :config="$datePickerOptions"
                                        v-mask="'##/##/####'"
                                    ></date-picker>
                                    <b-form-invalid-feedback
                                        >Vigência inicial é
                                        obrigatório</b-form-invalid-feedback
                                    >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label>Vigência Final</label>
                                <b-input-group>
                                    <date-picker
                                        v-model="dtFimVigencia"
                                        @input.native="
                                            $v.dtFimVigencia.$touch()
                                        "
                                        :config="$datePickerOptions"
                                        v-mask="'##/##/####'"
                                    ></date-picker>
                                    <b-form-invalid-feedback
                                        >Vigência final é
                                        obrigatório</b-form-invalid-feedback
                                    >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label>Gestor</label>
                                <b-input-group>
                                    <b-form-select
                                        v-model="codGestor"
                                        type="text"
                                        :options="gestores"
                                        value-field="codFuncionario"
                                        text-field="nome"
                                        :disabled="!habilitaCampos"
                                    >
                                    </b-form-select>
                                    <b-form-invalid-feedback
                                        >Gestor é
                                        obrigatório</b-form-invalid-feedback
                                    >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label>Unidade</label>
                                <b-input-group>
                                    <b-form-select
                                        v-model="codUnidade"
                                        type="text"
                                        :options="unidades"
                                        value-field="codUnidade"
                                        text-field="nome"
                                        :disabled="!habilitaCampos"
                                    ></b-form-select>
                                    <b-form-invalid-feedback
                                        >Unidade é
                                        obrigatório</b-form-invalid-feedback
                                    >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="3" lg="3" xl="3">
                            <b-form-group>
                                <label
                                    >Tipo Convênio
                                    <b-badge variant="primary" class="ml-2"
                                        >Integração com RM</b-badge
                                    >
                                </label>
                                <b-form-select
                                    :options="tiposConveniosRm"
                                    v-model="codTipoConvenio"
                                    text-field="descricao"
                                    value-field="codigo"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3" lg="3" xl="3">
                            <b-form-group>
                                <label
                                    >Tipo para Faturamento
                                    <b-badge variant="primary" class="ml-2"
                                        >Integração com RM</b-badge
                                    ></label
                                >
                                <b-form-select
                                    :options="tiposProdutosFaturamentoRm"
                                    v-model="codTipoProdutoFaturamento"
                                    text-field="descricao"
                                    value-field="codigo"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3" lg="3" xl="3">
                            <b-form-group>
                                <label
                                    >Natureza<b-badge
                                        variant="primary"
                                        class="ml-2"
                                        >Integração com RM</b-badge
                                    ></label
                                >
                                <b-form-select
                                    :options="tiposNatureza"
                                    text-field="descricao"
                                    value-field="codigo"
                                    v-model="codTipoNatureza"
                                >
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3" lg="3" xl="3">
                            <b-form-group>
                                <label
                                    >Natureza de Despesa<b-badge
                                        variant="primary"
                                        class="ml-2"
                                        >Integração com RM</b-badge
                                    ></label
                                >
                                <b-form-select
                                    :options="tiposNatureza"
                                    text-field="descricao"
                                    value-field="codigo"
                                    v-model="codTipoNaturezaDespesa"
                                >
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="3" lg="3" xl="3">
                            <b-form-group>
                                <label
                                    >Natureza de Receita<b-badge
                                        variant="primary"
                                        class="ml-2"
                                        >Integração com RM</b-badge
                                    ></label
                                >
                                <b-form-select
                                    :options="tiposNatureza"
                                    text-field="descricao"
                                    value-field="codigo"
                                    v-model="codTipoNaturezaReceita"
                                >
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3" lg="3" xl="3">
                            <b-form-group>
                                <label
                                    >Gestor do Convênio
                                    <b-badge variant="primary" class="ml-2"
                                        >Integração com RM</b-badge
                                    ></label
                                >
                                <b-form-select
                                    :options="vendedores"
                                    v-model="codGestorRM"
                                    text-field="nome"
                                    value-field="codigo"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3" lg="3" xl="3">
                            <b-form-group>
                                <label
                                    >Gerente do gestor
                                    <b-badge variant="primary" class="ml-2"
                                        >Integração com RM</b-badge
                                    ></label
                                >
                                <b-form-select
                                    :options="vendedores"
                                    v-model="codGerenteGestor"
                                    text-field="nome"
                                    value-field="codigo"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3" lg="3" xl="3">
                            <b-form-group>
                                <label
                                    >Representante
                                    <b-badge variant="primary" class="ml-2"
                                        >Integração com RM</b-badge
                                    ></label
                                >
                                <b-form-select
                                    :options="representantes"
                                    text-field="nome"
                                    value-field="codigo"
                                    v-model="codRepresentante"
                                >
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-card-body>
            <b-card-footer>
                <b-button
                    variant="primary"
                    class="mr-2"
                    :disabled="this.$v.$invalid"
                    @click.stop="salvar()"
                >
                    <span> <i class="fa fa-save mr-2"></i> Salvar </span>
                </b-button>
                <b-button variant="danger" @click.stop="voltar()" class="mr-2">
                    <span> <i class="fa fa-history mr-2"></i> Voltar </span>
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ConveniosServicos from '../ConveniosServicos'

export default {
    validations: {
        idProcessoAta: { required },
        vcCodigoEstruturado: { required },
        vcObjeto: { required },
        dtInicioVigencia: { required },
        dtFimVigencia: { required },
        nuValorReceitaPrevista: { required, minValue: minValue(0.01) },
        convenenteRM: {
            cnpj: { required }
        },
        nuAtaDirex: { required }
    },

    data() {
        return {
            convenio: null,
            tiposConveniosRm: [],
            tiposProdutosFaturamentoRm: [],
            tiposNatureza: [],
            vendedores: [],
            representantes: [],
            habilitaCampos: true,
            tabIndex: 0,
            operacao: '',
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            erros: [],
            gestores: [],
            unidades: [],
            itensPorPagina: 5,
            idProcessoAta: null,
            codGestor: null,
            codUnidade: null,
            codTipoConvenio: null,
            codTipoProdutoFaturamento: null,
            codTipoNatureza: null,
            codTipoNaturezaDespesa: null,
            codTipoNaturezaReceita: null,
            codGestorRM: null,
            codGerenteGestor: null,
            codRepresentante: null,
            idConvenio: 0,
            vcObjeto: '',
            vcCodigoEstruturado: '',
            codConvenente: 0,
            codGestor: 0,
            codUnidade: 0,
            idSituacaoConvenio: 1,
            processosAta: [],
            nuAtaDirex: '',
            processoAta: {
                id: 0,
                idAtaDirex: 0,
                vcObjetoProcesso: '',
                vcNomeSolicitanteGdoc: '',
                nuProcesso: '',
                ataDirex: {
                    cdTipoAta: 0,
                    cdTipoProcessoAta: null,
                    dtCadastro: null,
                    dtReuniao: null,
                    idAtaDirex: 0,
                    idSolicitanteRm: null,
                    idUnidadeRm: null,
                    nuSituacaoAta: 0,
                    nuValorTotalAta: null,
                    txObjeto: '',
                    usrLogin: ''
                }
            },
            convenenteRM: {
                cnpj: '',
                codFornecedor: '',
                email: '',
                nome: '',
                telefone: ''
            },
            gestor: {
                codFuncionario: 0,
                nome: '',
                email: ''
            },
            unidade: {
                codUnidade: '',
                nome: ''
            },
            dtInicioVigencia: '',
            dtFimVigencia: '',
            nuValorReceitaPrevista: 0.0,
            totalReceitas: 0.0,
            totalRendimentos: 0.0,
            nuValorConvenio: 0.0
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: 'Convenios' })
        },

        editarConvenio(id) {
            this.$router.push({
                name: 'Convenios_Detalhar',
                params: {
                    convenioId: id
                }
            })
        },

        obterConvenio() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.$route.params.convenioId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.habilitaAplicacaoRecursoAcao =
                                response.data.tipoAplicacaoRecurso == 'A'
                            this.convenio = response.data
                            this.vcCodigoEstruturado =
                                this.convenio.vcCodigoEstruturado
                            this.dtInicioVigencia = this.$moment(
                                response.data.dtInicioVigencia
                            ).format('DD/MM/YYYY')
                            this.dtFimVigencia = this.$moment(
                                response.data.dtFimVigencia
                            ).format('DD/MM/YYYY')
                            this.processoAta = this.convenio.processoAta
                            this.idProcessoAta = this.convenio.idProcessoAta
                            this.vcObjeto = this.convenio.vcObjeto
                            this.convenenteRM = this.convenio.convenenteRM
                            this.nuValorConvenio = this.convenio.nuValorConvenio
                            this.nuValorReceitaPrevista =
                                this.convenio.nuValorReceitaPrevista
                            this.codGestor = this.convenio.codGestor
                            this.codUnidade = this.convenio.codUnidade
                            this.codTipoConvenio = this.convenio.codTipoConvenio
                            this.codTipoProdutoFaturamento =
                                this.convenio.codTipoProdutoFaturamento
                            this.codTipoNatureza = this.convenio.codTipoNatureza
                            this.codTipoNaturezaDespesa =
                                this.convenio.codTipoNaturezaDespesa
                            this.codTipoNaturezaReceita =
                                this.convenio.codTipoNaturezaReceita
                            this.codGestorRM = this.convenio.codGestorRM
                            this.codGerenteGestor =
                                this.convenio.codGerenteGestor
                            this.codRepresentante =
                                this.convenio.codRepresentante
                            this.nuAtaDirex = this.convenio.nuAtaDirex
                            this.pesquisarAtaDirex()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        salvar() {
            var convenioDto = {
                totalReceitas: this.totalReceitas,
                totalRendimentos: this.totalRendimentos,
                idConvenio: this.idConvenio,
                vcCodigoEstruturado: this.vcCodigoEstruturado,
                idProcessoAta: this.idProcessoAta,
                vcObjeto: this.vcObjeto,
                convenenteRM: this.convenenteRM,
                nuValorConvenio: this.nuValorConvenio,
                nuValorReceitaPrevista: this.nuValorReceitaPrevista,
                dtInicioVigencia: this.$moment(
                    this.dtInicioVigencia,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD'),
                dtFimVigencia: this.$moment(
                    this.dtFimVigencia,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD'),
                codGestor: this.codGestor,
                codUnidade: this.codUnidade,
                codTipoConvenio: this.codTipoConvenio,
                codTipoProdutoFaturamento: this.codTipoProdutoFaturamento,
                codTipoNatureza: this.codTipoNatureza,
                codTipoNaturezaDespesa: this.codTipoNaturezaDespesa,
                codTipoNaturezaReceita: this.codTipoNaturezaReceita,
                codGestorRM: this.codGestorRM,
                codGerenteGestor: this.codGerenteGestor,
                codRepresentante: this.codRepresentante,
                nuAtaDirex: this.nuAtaDirex,
                codConvenente: this.codConvenente,
                gestor: this.gestor,
                unidade: this.unidade,
                processoAta: this.processoAta,
                idSituacaoConvenio: this.idSituacaoConvenio
            }
            if (this.operacao == 'INSERÇÃO') {
                this.$store.dispatch('addRequest')
                ConveniosServicos.inserirConvenio(convenioDto).then(
                    (response) => {
                        if (response) {
                            if (response.success) {
                                this.convenio = response.data
                                this.editarConvenio(this.convenio.idConvenio)
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
                )
            } else {
                convenioDto.idConvenio = this.$route.params.convenioId

                this.$store.dispatch('addRequest')
                ConveniosServicos.AlterarConvenio(convenioDto).then(
                    (response) => {
                        if (response) {
                            if (response.success) {
                                this.convenio = response.data
                                this.editarConvenio(this.convenio.idConvenio)
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
                )
            }
        },

        obterGestores() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterGestores().then((response) => {
                if (response) {
                    if (response.success) {
                        this.gestores = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterUnidades() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterUnidades().then((response) => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        pesquisarAtaDirex() {
            if (this.nuAtaDirex.length == 7) {
                this.$store.dispatch('addRequest')
                ConveniosServicos.obterProcessosPorNumeroAta(
                    this.nuAtaDirex.replace('/', '-')
                ).then((response) => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.erros = []
                            this.processosAta = response.data
                        } else {
                            this.processosAta = []
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        pesquisarConvenente() {
            if (
                this.convenenteRM.cnpj.length == 14 ||
                this.convenenteRM.cnpj.length == 18
            ) {
                let cpfcnpjSemCaracteresEspeciais =
                    this.convenenteRM.cnpj.replace(/\D+/g, '')
                this.$store.dispatch('addRequest')
                ConveniosServicos.obterFornecedor(
                    cpfcnpjSemCaracteresEspeciais
                ).then((response) => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.erros = []
                            this.codConvenente = response.data.codFornecedor
                            this.convenenteRM.nome = response.data.nome
                            this.convenenteRM.codFornecedor =
                                response.data.codFornecedor
                        } else {
                            this.erros.push('Convenente não encontrado')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        obterTiposConvenios() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterTiposConveniosRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposConveniosRm = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        ObterTipoProdutoFaturamento() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterTipoProdutoFaturamentoRM().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.tiposProdutosFaturamentoRm = response.data
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        ObterTipoNatureza() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ObterTipoNaturezaRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposNatureza = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        ObterVendedores() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ObterVendedoresRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.vendedores = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        ObterRepresentantes() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ObterRepresentantesRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.representantes = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencher() {
            this.habilitaCampos = true
            this.obterGestores()
            this.obterUnidades()
            this.obterTiposConvenios()
            this.ObterTipoProdutoFaturamento()
            this.ObterTipoNatureza()
            this.ObterVendedores()
            this.ObterRepresentantes()
            if (this.$route.params.convenioId > 0) {
                this.operacao = 'EDIÇÃO'
                this.habilitaCampos = false
                this.obterConvenio()
            } else {
                this.operacao = 'INSERÇÃO'
            }
        }
    },

    watch: {
        idProcessoAta() {
            if (this.operacao != 'EDIÇÃO')
                for (var i = 0, l = this.processosAta.length; i <= l; i++) {
                    this.vcObjeto = this.processosAta[i].vcObjetoProcesso
                    return
                }
        }
    },

    created() {
        this.preencher()
    }
}
</script>
